import classNames from "classnames";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { connect, ConnectedProps } from "react-redux";

import ManageReportViewModal from "./ManageReportViewModal";
import { subpageContext } from "components/layout/ApplicationLayout";
import Modal from "components/modal/Modal";
import style from "components/reports/import-report-view.scss";
import ImportReportViewsDialog from "components/reports/views/ImportReportViewsDialog";
import { CustomReportView } from "domain/reports";
import { reportViewService } from "services/report/ReportViewService";
import { StoreState } from "store";
import buttons from "styles/buttons.scss";
import form from "styles/form.scss";

import FailedRedNotificationIcon from "assets/images/icons/alert.svg";

import testIds from "testIds.json";

interface Props {
    modalVisible: boolean;
    setModalVisible: (visible: boolean) => void;
}

const connector = connect((state: StoreState) => ({
    theme: state.themeReducer.theme,
}));
const ImportReportView = (props: Props & ConnectedProps<typeof connector>): JSX.Element => {
    const { t } = useTranslation();
    const [confirmationModalVisible, setConfirmationModalVisible] = React.useState(false);
    const context = React.useContext(subpageContext);
    const paths = reportViewService.getPaths();

    const hideModal = () => {
        props.setModalVisible(true);
        setConfirmationModalVisible(true);
    };

    const hideConfiramationModal = () => {
        props.setModalVisible(true);
        setConfirmationModalVisible(false);
    };

    const cancelModals = () => {
        setConfirmationModalVisible(false);
        props.setModalVisible(false);
    };

    const updateModal = (reportViewValues: CustomReportView) => {
        props.setModalVisible(false);
        context?.setSubpage({
            content: (
                <ManageReportViewModal
                    key={reportViewValues.name}
                    visible={true}
                    handleVisibility={() => true}
                    paths={paths}
                    create={true}
                    viewDetails={reportViewValues}
                />
            ),
            isModal: false,
        });
    };

    return (
        <>
            <Modal isOpen={props.modalVisible} hideModal={hideModal} modalTitle={t("ImportReportView.title")}>
                <ImportReportViewsDialog onClose={updateModal} />
            </Modal>
            <Modal
                key={1}
                isOpen={confirmationModalVisible}
                hideModal={hideConfiramationModal}
                modalTitle={t("ImportReportView.confirmationView.title")}
            >
                <>
                    <div className={style.iconStyle}>
                        <img className={style.image} src={FailedRedNotificationIcon} />
                    </div>
                    <div className={style.resultContainer}>
                        {t("ImportReportView.confirmationView.confirmationMessage")}
                    </div>
                    <div className={classNames(form.okButtonContainer, style.buttonContainer)}>
                        <button
                            className={buttons.secondaryButtonWithoutIcon}
                            onClick={hideConfiramationModal}
                            data-testid={testIds.common.dialog.goBackButton}
                        >
                            {t("Common.goBack")}
                        </button>

                        <button
                            className={classNames(buttons.primaryButtonWithoutIcon, buttons.deleteButton)}
                            data-testid={testIds.common.dialog.closeButton}
                            onClick={cancelModals}
                        >
                            {t("ImportReportView.confirmationView.cancelButton")}
                        </button>
                    </div>
                </>
            </Modal>
        </>
    );
};

export default connector(ImportReportView);
